const storeUtils = require('../utils/storeUtils');
let messages;

module.exports = {
  get: () => {
    if (messages === undefined) {
      messages = storeUtils.get('messages');
    }

    return messages;
  },
};
